@let configuration = configurationSg();

<div class="atn-space-report-rooms-by-account">
  <atn-ds-widget title="Configuration">
    <div class="atn-space-report-rooms-by-account__configuration">
      <atn-ds-select-single
        label="Format"
        [items]="formatItems"
        [value]="configuration.format"
        [required]="true"
        (valueChange)="formatChangeHandler($event)"
      />
    </div>
  </atn-ds-widget>

  <atn-ds-widget title="Filters">
    <div class="atn-space-report-rooms-by-account__filters">
      <atn-ds-section name="Accounts">
        <div class="atn-space-report-rooms-by-account__filter-section">
          <atn-space-dimension-filter
            label="Account"
            [plugin]="accountFilterPlugin"
          />
        </div>
      </atn-ds-section>
    </div>
  </atn-ds-widget>
</div>
